import computedStyle from './computedStyle';

const parseComputetStyle = (node, prop) => parseInt(computedStyle(node).getPropertyValue(prop), 10);
export default parseComputetStyle